import { render, staticRenderFns } from "./StockLogs.vue?vue&type=template&id=51070b5a"
import script from "./StockLogs.vue?vue&type=script&lang=js"
export * from "./StockLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports